// extracted by mini-css-extract-plugin
export default {"contactContainer":"RegisterMessageBox_contactContainer__yzzfu","icon":"RegisterMessageBox_icon__r4u68","contactBody":"RegisterMessageBox_contactBody__Hj0Yk"};